module.exports = __webpack_public_path__ + "static/img/news2.9ef6e06.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news5/news2.jpg
// module id = PkvF
// module chunks = 1